





























































































































































































































































































import PromoteConfirmDialogue from '~/components/car/classifieds/promote/PromoteConfirmDialogue.vue'
import { mapActions, mapGetters, mapState } from 'vuex'
import { USER_NS } from '~/store/modules/shared/user/state'
import PromoButton from '~/components/car/classifieds/promote/PromoButton.vue'
import { SET_CREDITS } from '~/store/modules/shared/user/mutation-types'
import ActivePromo from '~/components/car/classifieds/promote/ActivePromo.vue'
import CConfirmationModal from '~/components/shared/configurable/modal/CConfirmationModal.vue'
import { CLASSIFIED_ACTIONS_NS } from '~/store/modules/shared/classifieds/actions/state'
import PromoteAdminButtons from '~/components/car/classifieds/promote/PromoteAdminButtons.vue'
import { CLASSIFIED_VIEW_NS } from '~/store/modules/shared/classifieds/view/state'
import { SET_HIDE_PROMOTION } from '~/store/modules/shared/classifieds/view/mutation-types'
import SinglePromoRegisterPrompt from '~/components/car/classifieds/promote/SinglePromoRegisterPrompt.vue'
import { formatNumber } from '~/utils/number'
import PreviousPromo from '~/components/car/classifieds/promote/PreviousPromo.vue'
import CTransitionExpand from '~/components/shared/configurable/expand/CTransitionExpand.vue'
import ClassifiedService from '~/services/classified/ClassifiedService'
import {
  ActivePromotion,
  PromoPaymentType,
  PromotionTier
} from '~/models/classified/promoted'
import { LegacyUrlService } from '~/services/legacy/url/LegacyUrlService'
import OneClickAutoTouchButton from '~/components/car/classifieds/promote/OneClickAutoTouchButton.vue'
import { AccessToggleName } from '~/models/user/access-toggles'
import { defineComponent } from '~/utils/nuxt3-migration'
import { defineComponentTranslations } from '~/utils/i18n'
import PaidCreditsFunctionalityBadge from '~/components/shared/badges/PaidCreditsFunctionalityBadge.vue'
import { ciChevronRight } from '~/icons/source/solid/chevron-right'
import { ciClock } from '~/icons/source/regular/clock'
import { ciStar } from '~/icons/source/solid/star'
import { ciTimesCircle } from '~/icons/source/solid/times-circle'

interface Data {
  availableTiers: PromotionTier[] | null
  selectedTier: PromotionTier | null
  showModal: boolean
  showDeleteModal: boolean
  errorMsg: string
  activePromotion: ActivePromotion | null
  availablePromotions: number | null
  modalStep: number
  banError: string
  previousPromotions: ActivePromotion[]
  showPrevious: boolean
  tiersLoaded: boolean
  isPromoButtonsLoading: boolean
  preferredPayment: PromoPaymentType
}

export default defineComponent({
  components: {
    OneClickAutoTouchButton,
    CTransitionExpand,
    PreviousPromo,
    SinglePromoRegisterPrompt,
    PromoteAdminButtons,
    CConfirmationModal,
    ActivePromo,
    PromoButton,
    PromoteConfirmDialogue,
    PaidCreditsFunctionalityBadge
  },
  props: {
    classified: { type: Object, required: true },
    refetchFunction: {
      // function for refetching something else, for example the classified view
      type: Function,
      required: false,
      default: null
    },
    inModal: {
      type: Boolean,
      required: false,
      default: false
    },
    inBlock: {
      type: Boolean,
      required: false,
      default: false
    },
    inIframe: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data(): Data {
    return {
      availableTiers: null,
      selectedTier: null,
      showModal: false,
      showDeleteModal: false,
      errorMsg: '',
      activePromotion: null,
      availablePromotions: null,
      modalStep: 1,
      banError: '',
      previousPromotions: [],
      showPrevious: false,
      tiersLoaded: false,
      isPromoButtonsLoading: false,
      preferredPayment: 'credits'
    }
  },
  computed: {
    ...mapGetters(USER_NS, {
      paidCredits: 'paidCredits',
      userIsAdmin: 'isAdmin',
      userIsSingle: 'isSingle',
      userHasPermission: 'hasPermission'
    }),
    ...mapState(CLASSIFIED_ACTIONS_NS, {
      actionPending: state => state.pending
    }),
    userCanSeeOneClickAutoTouchButton() {
      return this.userHasPermission(AccessToggleName.ONE_CLICK_AUTO_TOUCH)
    },

    noRefundMsg() {
      return this.$t('this_action_will_cancel_promo', {
        refund:
          this.preferredPayment === 'credits'
            ? this.$t('credits_not_refundable')
            : this.$t('money_not_refundable')
      })
    },
    icons() {
      return {
        star: ciStar,
        ban: ciTimesCircle,
        chevronRight: ciChevronRight,
        clock: ciClock
      }
    },

    paidCreditsFormatted() {
      return formatNumber(this.paidCredits)
    },
    buyCreditsUrl() {
      const legacyUrlService = this.$dep(LegacyUrlService)
      return legacyUrlService.getBuyCreditsUrl()
    }
  },
  watch: {
    activePromotion(newVal) {
      if (newVal) {
        this.$emit('show-help-tip', false)
      } else {
        this.$emit('show-help-tip', true)
      }
    }
  },
  mounted() {
    this.fetchPromoInfo()
  },
  methods: {
    ...mapActions(CLASSIFIED_ACTIONS_NS, {
      performAction: 'performAction'
    }),
    fetchPromoInfo() {
      this.performAction(async () => {
        this.banError = ''
        this.errorMsg = ''
        this.availablePromotions = null
        this.activePromotion = null

        const classifiedService = this.$dep(ClassifiedService)
        const response = await classifiedService.getPromoteInfo(
          this.classified.id
        )
        if (response) {
          this.$emit('fetch-promo-complete', response.preferredPayment)
          this.preferredPayment = response.preferredPayment
          if (this.userIsSingle && this.inIframe) {
            this.modalStep = 2
            if (response.availableTiers) {
              this.setAvailableTiers(response.availableTiers)
            }
          } else if (
            !this.userIsSingle &&
            (!response.promotion || !response.promotion.available)
          ) {
            // hide promo block
            this.$store.commit(
              `${CLASSIFIED_VIEW_NS}/${SET_HIDE_PROMOTION}`,
              true
            )
          } else {
            if (response.promotion) {
              if (response.promotion.activePromotion) {
                this.activePromotion = response.promotion.activePromotion
              }
              if (response.promotion.previousPromotions) {
                this.previousPromotions = response.promotion.previousPromotions
              }
            }

            if (response.availableTiers) {
              // sort them with the expensive showing first
              this.setAvailableTiers(response.availableTiers)
            }

            if (
              response.availablePromotions ||
              response.availablePromotions === 0
            ) {
              this.availablePromotions = response.availablePromotions
            }
          }
        } else {
          this.availableTiers = []
        }
      }).catch(error => {
        let errorMessage = ''
        if (error.response && error.response.data) {
          errorMessage =
            error.response.data.message || error.response.data.error
        } else {
          errorMessage = this.$t('an error occurred please try again later')
        }
        if ([455, 451, 401, 400].includes(error.response.data.status)) {
          if (this.userIsAdmin || this.inModal) {
            // do stuff
            this.banError = errorMessage
          } else {
            this.$store.commit(
              `${CLASSIFIED_VIEW_NS}/${SET_HIDE_PROMOTION}`,
              true
            )
          }
        } else {
          this.errorMsg = errorMessage
        }
      })
    },
    onTierSelect(tier: PromotionTier) {
      this.selectedTier = tier

      if (this.preferredPayment === 'stripe') {
        this.buyPromo()
        this.isPromoButtonsLoading = true
        return
      }

      if (this.paidCredits !== null) {
        if (
          (!this.selectedTier.canBeBought &&
            this.selectedTier.cost < this.paidCredits) ||
          (this.selectedTier.canBeBought &&
            this.selectedTier.cost >= this.paidCredits)
        ) {
          // edge case (probably inModal) where credits have been updated in backend but not in front
          this.$store.dispatch(`${USER_NS}/loadUser`, {}, { root: true })
        }
      }

      if (this.inModal) {
        this.modalStep = 2
        this.$emit('show-help-tip', false)
      } else {
        this.showModal = true
      }
    },
    checkForCredits() {
      this.performAction(async () => {
        const tierBeforeUpdate = this.selectedTier
        this.selectedTier = null

        const classifiedService = this.$dep(ClassifiedService)
        const response = await classifiedService.getPromoteInfo(
          this.classified.id
        )

        if (response && response.availableTiers) {
          this.setAvailableTiers(response.availableTiers)

          if (tierBeforeUpdate) {
            this.selectedTier = response.availableTiers.find(t => {
              return t.tier === tierBeforeUpdate.tier
            })
            if (this.inModal) {
              this.$emit('show-help-tip', false)
            }
          }
        } else {
          this.errorMsg = this.$t('an error occurred please try again later')
        }

        // update the available credits in store:
        this.$store.dispatch(`${USER_NS}/loadUser`, {}, { root: true })
      }).catch(error => {
        let errorMessage = ''
        if (error.response && error.response.data) {
          errorMessage =
            error.response.data.message || error.response.data.error
        }
        if (errorMessage) {
          this.errorMsg = errorMessage
        } else {
          this.errorMsg = this.$t('an error occurred please try again later')
        }
      })
    },
    buyPromo() {
      const lockedTier = this.selectedTier

      this.performAction(async () => {
        if (lockedTier) {
          this.selectedTier = null

          const classifiedService = this.$dep(ClassifiedService)
          let response = null
          try {
            response = await classifiedService.promoteClassified(
              this.classified.id,
              lockedTier.tier,
              this.preferredPayment
            )
            this.isPromoButtonsLoading = false
          } catch (error) {
            if (error.response && error.response.data) {
              this.errorMsg =
                error.response.data.message || error.response.data.error
              return
            } else {
              this.errorMsg = this.$t(
                'an error occurred please try again later'
              )
            }
          }

          if (this.preferredPayment === 'stripe') {
            this.isPromoButtonsLoading = false
            window.location.href = response.url
            return
          }

          if (this.inModal) {
            this.$emit('close-modal')
          } else {
            this.showModal = false
          }
          if (response.promotion && response.promotion.activePromotion) {
            this.activePromotion = response.promotion.activePromotion
            this.$emit('set-active-promotion', this.activePromotion)
          }

          if (response.availableCredits) {
            this.$store.commit(
              `${USER_NS}/${SET_CREDITS}`,
              response.availableCredits
            )
          }

          if (this.refetchFunction) {
            await this.refetchFunction()
          }

          this.$snackbar.success(this.$t('promotion has been activated'))
        }
      }).catch(error => {
        if (error.response.data.status === 402) {
          // no credits
          this.selectedTier = lockedTier
          this.checkForCredits()
        } else {
          let errorMessage = ''
          if (error.response && error.response.data) {
            errorMessage =
              error.response.data.message || error.response.data.error
          }
          if (errorMessage) {
            this.errorMsg = errorMessage
          } else {
            this.errorMsg = this.$t('an error occurred please try again later')
          }
        }
      })
    },
    cancelPromotion() {
      this.performAction(async () => {
        const lockedPromo = this.activePromotion

        if (lockedPromo) {
          const classifiedService = this.$dep(ClassifiedService)
          await classifiedService.cancelPromotion(this.classified.id)

          this.selectedTier = null
          this.activePromotion = null
          this.$emit('set-active-promotion', null)

          if (this.refetchFunction) {
            await this.refetchFunction()
          }

          this.$snackbar.success(this.$t('promotion has been canceled'))
        }
      })
        .catch(error => {
          let errorMessage = ''
          if (error.response && error.response.data) {
            errorMessage =
              error.response.data.message || error.response.data.error
          }
          if (errorMessage) {
            this.$snackbar.error(errorMessage)
          } else {
            this.$snackbar.error(
              this.$t('an error occurred please try again later')
            )
          }
        })
        .finally(() => {
          if (this.inModal) {
            this.$emit('close-modal')
          }
        })
    },
    banPromoClassified() {
      this.performAction(async () => {
        const classifiedService = this.$dep(ClassifiedService)
        await classifiedService.banPromoClassified(this.classified.id)

        this.$snackbar.success(
          this.$t('promotion has been disabled for this classified')
        )

        if (this.inBlock) {
          await this.fetchPromoInfo()
        }
      })
        .catch(error => {
          let errorMessage = ''
          if (error.response && error.response.data) {
            errorMessage =
              error.response.data.message || error.response.data.error
          }
          if (errorMessage) {
            this.$snackbar.error(errorMessage)
          } else {
            this.$snackbar.error(
              this.$t('an error occurred please try again later')
            )
          }
        })
        .finally(() => {
          if (this.inModal) {
            this.$emit('close-modal')
          }
        })
    },
    enablePromoClassified() {
      this.performAction(async () => {
        const classifiedService = this.$dep(ClassifiedService)
        await classifiedService.enablePromoClassified(this.classified.id)

        this.$snackbar.success(
          this.$t('promotion has been enabled for this classified')
        )

        if (this.inBlock) {
          await this.fetchPromoInfo()
        }
      })
        .catch(error => {
          let errorMessage = ''
          if (error.response && error.response.data) {
            errorMessage =
              error.response.data.message || error.response.data.error
          }
          if (errorMessage) {
            this.$snackbar.error(errorMessage)
          } else {
            this.$snackbar.error(
              this.$t('an error occurred please try again later')
            )
          }
        })
        .finally(() => {
          if (this.inModal) {
            this.$emit('close-modal')
          }
        })
    },
    banPromoUser() {
      this.performAction(async () => {
        const classifiedService = this.$dep(ClassifiedService)
        await classifiedService.banPromoUser(this.classified.id)

        this.$snackbar.success(
          this.$t('promotions have been disabled for this user')
        )

        if (this.inBlock) {
          await this.fetchPromoInfo()
        }
      })
        .catch(error => {
          let errorMessage = ''
          if (error.response && error.response.data) {
            errorMessage =
              error.response.data.message || error.response.data.error
          }
          if (errorMessage) {
            this.$snackbar.error(errorMessage)
          } else {
            this.$snackbar.error(
              this.$t('an error occurred please try again later')
            )
          }
        })
        .finally(() => {
          if (this.inModal) {
            this.$emit('close-modal')
          }
        })
    },
    enablePromoUser() {
      this.performAction(async () => {
        const classifiedService = this.$dep(ClassifiedService)
        await classifiedService.enablePromoUser(this.classified.id)

        this.$snackbar.success(
          this.$t('promotions have been enabled for this user')
        )

        if (this.inBlock) {
          await this.fetchPromoInfo()
        }
      })
        .catch(error => {
          let errorMessage = ''
          if (error.response && error.response.data) {
            errorMessage =
              error.response.data.message || error.response.data.error
          }
          if (errorMessage) {
            this.$snackbar.error(errorMessage)
          } else {
            this.$snackbar.error(
              this.$t('an error occurred please try again later')
            )
          }
        })
        .finally(() => {
          if (this.inModal) {
            this.$emit('close-modal')
          }
        })
    },
    setAvailableTiers(tiers: PromotionTier[]) {
      if (this.activePromotion === null) {
        this.$emit('show-help-tip', true)
      }
      const sorted = tiers.sort((a, b) =>
        b.cost > a.cost ? 1 : a.cost > b.cost ? -1 : 0
      )
      this.availableTiers = sorted

      for (let i = 0; i < this.availableTiers.length; i++) {
        const promo = this.availableTiers[i]
        if (this.paidCredits !== null) {
          if (
            (!promo.canBeBought && promo.cost < this.paidCredits) ||
            (promo.canBeBought && promo.cost >= this.paidCredits)
          ) {
            // edge case (probably inModal) where credits have been updated in backend but not in front
            this.$store.dispatch(`${USER_NS}/loadUser`, {}, { root: true })
            break
          }
        }
      }

      this.tiersLoaded = true
    },
    handleCancelPromotion() {
      if (this.inModal) {
        this.modalStep = 3
        this.$emit('show-help-tip', false)
      } else {
        this.showDeleteModal = true
      }
    },
    onCancelClick() {
      this.selectedTier = null
      this.modalStep = 1
      this.$emit('show-help-tip', true)
    }
  },
  i18n: defineComponentTranslations({})
})
